<template>
    <div style="height:100%" class="menue">
        <template v-for="item in getMenu">
            <el-menu-item :index="item.menuUrl?item.menuUrl.substr(item.menuUrl.lastIndexOf('/')):item.id+''" :key="item.id" v-if="!item.children">
                <i :class="[{icon:true,iconfont:true},item.menuIcon]" style=" font-size:18px;"></i>
                <span slot="title">{{item.menuName}}</span>
            </el-menu-item>
            <el-submenu :index="item.menuUrl?item.menuUrl.substr(item.menuUrl.lastIndexOf('/')):item.id+''"  v-else :key="item.id">
                <template slot="title">
                    <i :class="[{icon:true,iconfont:true},item.menuIcon]" style="font-size:18px;"></i>
                    <span :class="{'hidden-close':isCollapse}">{{item.menuName}}</span>
                </template>
                <common-menu :getMenu="item.children"></common-menu>
            </el-submenu>
        </template>
    </div>
</template>
<script>
export default {
    name:'CommonMenu',
    props:{
        getMenu:Array,
        isCollapse:Boolean
    }
}
</script>
<style >
.menue .el-menu-item,.menue .el-submenu__title{
    height:38px !important;
    line-height: 38px !important;
}
.menue .el-menu--inline .el-menu-item{
    height:30px !important;
    line-height: 30px !important;
}
.el-menu-item.is-active{
   font-size:15px;
   font-weight: 500;
}
.hidden-close{
    display: none;
}
.menue .el-icon-arrow-right{
    display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/menu.vue